import { formatUrl, route } from './route';
import { obligationRoutes } from './obligation';

export const appRoutes = {
    home: () => route('/(app)'),
    sandbox: () => route('/(app)/sandbox'),
    creditReports: () => route('/(app)/credit-reports'),
    jobs: () => route('/(app)/jobs'),
    liveJobs: () => route('/(app)/livejobs'),
    statements: () => route('/(app)/statements'),
    trueBi: () => route('/(app)/truebi'),
    featureFlags: () => route('/(app)/feature-flags'),
    search: (params?: URLSearchParams) => formatUrl(route('/(app)/search'), params),

    utilities: {
        overview: () => route('/(app)/utilities'),
        postalCodeTimeZones: () => route('/(app)/utilities/postal-code-timezones'),
        batchChecks: {
            list: () => route('/(app)/utilities/batch-checks'),
            detail: (batchId: number) => route('/(app)/utilities/batch-checks/[id=integer]', { id: String(batchId) })
        }
    },

    user: {
        activities: () => route('/(app)/user/activities'),
        edit: () => route('/(app)/user/edit')
    },

    tasks: {
        list: () => route('/(app)/tasks'),
        detail: (taskId: number) => route('/(app)/tasks/[id=integer]', { id: String(taskId) }),
        approvals: () => route('/(app)/tasks/approvals')
    },

    collections: {
        workQueue: () => route('/(app)/collections/work-queue'),
        workQueueObligation: (obligationId: number, taskId: number) =>
            formatUrl(
                obligationRoutes.detail(obligationId),
                new URLSearchParams({ workflow: 'collections', taskId: String(taskId) })
            )
    }
};
